import { Button } from "@/components/ui/button";
import { useUnschedule } from "./use-unschedule";

// 放回需求池 (versionId → NULL, relation row kept). One simple rule (owner
// 2026-08-18): only while the version is 规划中 (state 0) — same everywhere
// (app Issues rows, version page rows, PRD detail header). Callers gate on
// state and pass the revalidation for their view.
const BackToPoolButton = ({
  engagementId,
  onDone,
}: {
  engagementId: string;
  onDone: () => void;
}) => {
  const { unschedule, unscheduling } = useUnschedule(onDone);
  return (
    <Button
      variant="destructive"
      size="xs"
      disabled={unscheduling}
      className="shrink-0"
      onClick={(e) => {
        e.stopPropagation();
        unschedule(engagementId);
      }}
    >
      放回需求池
    </Button>
  );
};

export default BackToPoolButton;
